import React, {useEffect, useState} from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeHighlight from 'rehype-highlight';
import rehypeRaw from 'rehype-raw'; // Add this import
import 'highlight.js/styles/github-dark.css'; // Choose your preferred code highlight theme
import '../styles/App.css';
import Navbar from '../components/NavBar';
import Footer from '../components/Footer';
import {useLocation, useParams} from "react-router-dom";
import {capitalizeFirstLetter, fetchBlogData} from "../utils/functions";

function BlogDetailPage() {
    const { searchName } = useParams();
    const [blogData, setBlogData] = useState([]);
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        const lang = location.pathname.startsWith('/hk') ? "zh-Hant-HK" : 'en';

        const loadData = async () => {
            try {
                const data = await fetchBlogData(lang);
                setBlogData(data);
            } catch (error) {
                console.error('Error loading blog data:', error);
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, [location.pathname]);

    const findBlogByTitle = (title) => {
        const formattedTitle = title
            .split('-')
            .map(word => capitalizeFirstLetter(word))
            .join(' ');
        return blogData.find(blog =>
            blog.searchName.toLowerCase().includes(formattedTitle.toLowerCase())
        );
    };

    const blog = findBlogByTitle(searchName);
    if (loading) {
        return <div>Loading...</div>;
    }

    if (!blog) {
        return <div>Blog post not found</div>;
    }

    return (
        <>
            <Navbar />
            <div className="blog-detail-container">
                <img
                    src={blog.image_url}
                    alt={blog.title}
                    className="blog-detail-image"
                />

                <div className="blog-detail-content-wrapper">
                    <h1 className="blog-detail-title">{blog.title}</h1>
                    <hr/>
                    <h2 className="blog-detail-subtitle">{blog.subtitle}</h2>
                    <div className="blog-detail-content">
                        <ReactMarkdown
                            remarkPlugins={[remarkGfm]}
                            rehypePlugins={[rehypeHighlight, rehypeRaw]}
                            components={{
                                // Add u component handler
                                u: ({node, ...props}) => <u {...props} />,
                                // Existing components
                                img: ({node, ...props}) => (
                                    <img {...props} style={{maxWidth: '100%'}} alt={props.alt}/>
                                ),
                                a: ({node, href, children, ...props}) => {
                                    const isZh = location.pathname.startsWith('/hk');
                                    let targetHref = href;
                                    let isInternal = false;
                                    if (href) {
                                        try {
                                            const url = new URL(href);
                                            isInternal = url.hostname === 'activikid.hk' || url.hostname === 'www.activikid.hk';
                                            if (isInternal && isZh && !url.pathname.startsWith('/hk')) {
                                                url.pathname = '/hk' + url.pathname;
                                                targetHref = url.toString();
                                            }
                                        } catch (e) {}
                                    }
                                    if (isInternal) {
                                        return <a href={targetHref} {...props}>{children}</a>;
                                    }
                                    return <a href={targetHref} target="_blank" rel="noopener noreferrer" {...props}>{children}</a>;
                                }
                            }}
                        >
                            {blog.content}
                        </ReactMarkdown>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    );
}

export default BlogDetailPage;